export function translateAlert(alert, t) {
  const { template, templateValues, msg } = alert;

  if (!template) return msg;

  const key = `alerts.events.${template}`;
  if (t(key) === key) return msg;

  return t(key, templateValues);
}
